import * as React from 'react';
import { cn } from '../../lib/utils';

interface PageHeaderProps {
  eyebrow?: React.ReactNode;
  title: React.ReactNode;
  description?: React.ReactNode;
  chip?: React.ReactNode;
  actions?: React.ReactNode;
  className?: string;
}

/**
 * Standard dashboard page header — "Pearl + Coral" premium variant.
 *
 * Light-weight display title (the bold version lives in dashBigNumber
 * for stat cards). Eyebrow uppercase + tracked. Generous space.
 */
export function PageHeader({ eyebrow, title, description, chip, actions, className }: PageHeaderProps) {
  return (
    <header
      className={cn(
        'px-6 sm:px-8 lg:px-10 pt-10 pb-6 flex flex-wrap items-end justify-between gap-x-6 gap-y-4',
        className,
      )}
    >
      <div className="min-w-0">
        {eyebrow ? (
          <p className="text-[11px] font-semibold uppercase tracking-[0.16em] text-ink/55 dark:text-white/55 mb-3">{eyebrow}</p>
        ) : null}
        <div className="flex items-center gap-3 flex-wrap">
          <h1 className="font-light text-display-page text-ink dark:text-white">{title}</h1>
          {chip ? <div className="self-center">{chip}</div> : null}
        </div>
        {description ? (
          <p className="text-[14.5px] text-ink/60 dark:text-white/60 mt-3 max-w-2xl leading-relaxed">{description}</p>
        ) : null}
      </div>
      {actions ? <div className="flex items-center gap-2 shrink-0">{actions}</div> : null}
    </header>
  );
}
